import React from 'react';
import { IconLoading } from '../../../components/buttons/IconButtons';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Shows the current state of the camera as a chip coloured by status.
 *
 * @param {Function} t Translation function.
 * @param {Object} currentAction Status configuration of the active scanner state.
 * @returns {JSX.Element}
 */
const ScannerStatusCard = ({ t, currentAction }) => {
    return (
        <div className={`scanner-status-chip scanner-status-${currentAction?.tone}`}>
            {currentAction?.loading
                ? <IconLoading className='scanner-status-spinner' width={16} height={16} />
                : <span className='scanner-status-dot' />
            }

            <span className='fs-14px ibl-font-w-600 text-uppercase'>{t('status')}</span>

            <span className='fs-14px ibl-font-w-400'>{t(currentAction?.label)}</span>
        </div>
    );
};

export default ScannerStatusCard;
